// src/components/StandardLayout.tsx
import React from "react";
import { ChatInterface } from "./chat-interface";
import type { DisplayMessage } from "../../types";
import { ReadyState } from "react-use-websocket";

interface StandardLayoutProps {
  roomId: string;
  messages: DisplayMessage[];
  sendMessage: (username: string, message: string) => void;
  connectionStatus: string;
  chatError: string | null;
  readyState: ReadyState;
}

export function StandardLayout({
  roomId,
  messages,
  sendMessage,
  connectionStatus,
  chatError,
  readyState,
}: StandardLayoutProps) {
  return (
    <div className="flex h-dvh w-full flex-col bg-white p-4">
      <ChatInterface
        roomId={roomId}
        messages={messages}
        sendMessage={sendMessage}
        connectionStatus={connectionStatus}
        chatError={chatError}
        readyState={readyState}
        isSidebar={false}
        isYoutubeRoom={false}
      />
    </div>
  );
}
